import { render, staticRenderFns } from "./stockout_detail.vue?vue&type=template&id=899ef3d4&scoped=true"
import script from "./stockout_detail.vue?vue&type=script&lang=js"
export * from "./stockout_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ef3d4",
  null
  
)

export default component.exports